<div class="mat-dialog-container-seguimiento">
  <div mat-dialog-title class="mat-dialog-title">
    <span class="mat-dialog-title-style">Seguimiento a cotización</span>
    <button mat-icon-button aria-label="close" class="close-button" (click)="onCancel()">✕</button>
  </div>

  <div mat-dialog-content class="mat-dialog-content">

    <!-- Cotización número -->
    <div class="field-row">
      <label class="field-label">Cotización número:</label>
      <mat-form-field appearance="outline" class="field-input">
        <input matInput [value]="numeroCotizacion" readonly>
      </mat-form-field>
    </div>

    <!-- Cliente -->
    <div class="field-row">
      <label class="field-label">Cliente:</label>
      <mat-form-field appearance="outline" class="field-input">
        <input matInput [value]="nombreCliente" readonly>
      </mat-form-field>
    </div>

    <!-- Fecha próximo contacto, Probabilidad, Canal de contacto preferido -->
    <div class="field-row-triple">
      <div class="field-col">
        <label class="field-label-top">Fecha próximo contacto:</label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput [matDatepicker]="picker" [(ngModel)]="fechaProximoContacto " 
              [disabled]="esJefeComercial"  [min]="fechaMinima" required>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="field-col">
        <label class="field-label-top">Probabilidad de cierre:</label>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select [(ngModel)]="probabilidadCierre" [disabled]="esJefeComercial" required>
            <mat-option *ngFor="let opcion of opcionesProbabilidad" [value]="opcion">
              {{opcion}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="field-col">
        <label class="field-label-top">Canal de contacto preferido:</label>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select [(ngModel)]="canalesContacto" multiple [disabled]="esJefeComercial" required>
            <mat-option *ngFor="let canal of opcionesCanales" [value]="canal">
              {{canal}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Observaciones -->
    <div class="field-row-full">
      <label class="field-label-top">Observaciones:</label>
      <mat-form-field appearance="outline" class="full-width">
        <textarea matInput [(ngModel)]="observaciones" [disabled]="esJefeComercial" maxlength="1000" rows="4"
          (ngModelChange)="onObservacionesChange()"
          placeholder="Espacio para comentarios y consideraciones del asesor..."></textarea>
        <mat-hint align="end">{{observaciones.length || 0}} / 1000</mat-hint>
        <mat-error *ngIf="observacionesError">Máximo 1000 caracteres.</mat-error>
      </mat-form-field>
      <button mat-mini-fab color="primary" class="btn-agregar" (click)="agregarObservacion()"
              [disabled]="esJefeComercial || !observaciones.trim() || observacionesError"
              matTooltip="Agregar observación al historial">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <!-- Historial de Observaciones -->
    <div class="historial-section">
      <h3 class="historial-titulo">HISTORIAL DE OBSERVACIONES</h3>
      
      <table class="historial-table">
        <thead>
          <tr>
            <th class="col-fecha">FECHA DE SEGUIMIENTO</th>
            <th class="col-observaciones">OBSERVACIONES</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of historialObservaciones">
            <td class="col-fecha">{{item.fecha}}</td>
            <td class="col-observaciones">{{item.observacion}}</td>
          </tr>
          <tr *ngIf="historialObservaciones.length === 0">
            <td colspan="2" class="sin-registros">No hay observaciones registradas</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

  <div mat-dialog-actions class="mat-dialog-actions">
    <button mat-raised-button color="primary" (click)="onCancel()">CERRAR</button>
    <button mat-raised-button color="primary" (click)="onGuardar()" 
      [disabled]="isGuardarDisabled()">
      GUARDAR
    </button>
  </div>
</div>
